// ┏━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┓
// ┃ ██████ ██████ ██████       █      █      █      █      █ █▄  ▀███ █       ┃
// ┃ ▄▄▄▄▄█ █▄▄▄▄▄ ▄▄▄▄▄█  ▀▀▀▀▀█▀▀▀▀▀ █ ▀▀▀▀▀█ ████████▌▐███ ███▄  ▀█ █ ▀▀▀▀▀ ┃
// ┃ █▀▀▀▀▀ █▀▀▀▀▀ █▀██▀▀ ▄▄▄▄▄ █ ▄▄▄▄▄█ ▄▄▄▄▄█ ████████▌▐███ █████▄   █ ▄▄▄▄▄ ┃
// ┃ █      ██████ █  ▀█▄       █ ██████      █      ███▌▐███ ███████▄ █       ┃
// ┣━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┫
// ┃ Copyright (c) 2017, the Perspective Authors.                              ┃
// ┃ ╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌╌ ┃
// ┃ This file is part of the Perspective library, distributed under the terms ┃
// ┃ of the [Apache License 2.0](https://www.apache.org/licenses/LICENSE-2.0). ┃
// ┗━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━┛

import "@perspective-dev/viewer";
import "@perspective-dev/viewer-datagrid";
import "@perspective-dev/viewer-charts";

import { initAboutDialog } from "./components/about_dialog.js";
import { initAgentDialog } from "./components/agent_dialog.js";
import { initSidebar } from "./components/sidebar.js";
import { initProjectGallery } from "./components/project_gallery.js";
import { initSourceModal } from "./components/source_modal.js";
import { initSqlDrawer } from "./components/sql_drawer.js";
import { bindViewer } from "./data/engines.js";
import { initTheme } from "./data/theme.js";
import { registerCartoTileSources } from "./data/tile_sources.js";
import type { HTMLPerspectiveViewerElement } from "@perspective-dev/viewer";

const shell = document.getElementById("app")!;
const viewer = document.getElementById(
    "viewer",
) as HTMLPerspectiveViewerElement;

registerCartoTileSources();
bindViewer(viewer);
void initTheme(viewer);

const sqlDrawer = initSqlDrawer(shell, viewer);
const { createSource, browseProjects, configureAgent } = initSidebar(
    shell,
    viewer,
    { openSql: () => sqlDrawer.toggle() },
);

const gallery = initProjectGallery(shell, viewer);
browseProjects.addEventListener("click", () => gallery.openModal());
initSourceModal(viewer, createSource);
initAgentDialog(viewer, configureAgent);
initAboutDialog();
